import { css } from '@emotion/react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ProColors } from '../../aura';
import { Step, useFormContext } from '../../state';

function getStepKey(step: Step) {
  return `step${step}`;
}

function StepCounter(): JSX.Element {
  const { t } = useTranslation('stepCounter');
  const { step } = useFormContext();

  return (
    <div
      className="aura--copy-xs"
      css={css({ color: ProColors.navy[800], textTransform: 'uppercase' })}
    >
      {t(getStepKey(step))}
    </div>
  );
}

type TitleProps = {
  text: ReactNode;
  showStepCounter?: boolean;
  className?: string;
};

export function Title(props: TitleProps): JSX.Element {
  const h1 = (
    <h1 className={`aura--h4 ${props.className || ''}`}>{props.text}</h1>
  );

  if (props.showStepCounter) {
    return (
      <div css={css({ display: 'flex', flexDirection: 'column', gap: 8 })}>
        <StepCounter />
        {h1}
      </div>
    );
  }
  return h1;
}
